
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.48 11.15c1.721 0 3.12 1.395 3.215 3.145l.005.188V15.9a.5.5 0 01-.992.09l-.008-.09v-1.417c0-1.239-.917-2.246-2.068-2.328l-.152-.005H5.72c-1.17 0-2.136.955-2.215 2.173l-.005.16V15.9a.5.5 0 01-.992.09L2.5 15.9v-1.417c0-1.773 1.34-3.23 3.037-3.328l.183-.005h4.76zm4.645-4.25a.5.5 0 01.492.41l.008.09v1.624l1.625.001a.5.5 0 01.09.992l-.09.008-1.625-.001v1.626a.5.5 0 01-.992.09l-.008-.09v-1.626L13 10.025a.5.5 0 01-.09-.992l.09-.008 1.625-.001V7.4a.5.5 0 01.5-.5zM8.1 3.5a3.05 3.05 0 110 6.1 3.05 3.05 0 010-6.1zm0 1a2.05 2.05 0 100 4.1 2.05 2.05 0 000-4.1z","fill":"#222"}})])
          )
        }
      }
    